{
  "rows": { "sources": ["payload"], "paths": ["rows", "records", "items", "list", "data"] },
  "total": { "sources": ["response", "payload"], "paths": ["total", "count", "totalCount"] },
  "tabs": { "sources": ["response", "payload"], "paths": ["tabs", "tabList"] },
  "fields": { "sources": ["response", "payload"], "paths": ["fields", "fieldConfig"] },
  "tabField": { "sources": ["payload"], "paths": ["tabField"] },
  "actionRules": { "sources": ["payload"], "paths": ["actionRules"] },
  "actions": { "sources": ["payload"], "paths": ["actions"] },
  "columnActions": { "sources": ["payload"], "paths": ["columnActions"] },
  "synthesizeFieldsFromRows": true,
  "visibilityFlag": null
}
